export default __webpack_public_path__ + "static/media/istio.65e6161a.svg";